import GmailAuth from "./GmailAuth";

interface EmailListStatesProps {
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  selectedInbox?: string;
  onReconnectSuccess: () => void;
}

export const EmailListStates = ({ 
  isLoading, 
  isError, 
  error, 
  selectedInbox, 
  onReconnectSuccess 
}: EmailListStatesProps) => {
  if (!selectedInbox) {
    return <div className="p-4 text-center text-muted-foreground">Select an inbox to view emails</div>;
  }

  if (isLoading) {
    return <div className="p-4 text-center">Loading emails...</div>;
  }

  if (isError || error) {
    console.error('Error loading emails:', error);
    return (
      <div className="p-4 flex flex-col items-center justify-center space-y-4">
        <p className="text-center text-red-500">Unable to fetch emails</p>
        <GmailAuth onSuccess={onReconnectSuccess} />
      </div>
    );
  }

  return null;
};